'use client';

import Script from 'next/script';

export function OptanonScript() {
    return (
        <Script
            id="optanon-script"
            data-testid="optanon-script"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
                            function OptanonWrapper() {
                                consentCheck();
                                OneTrust.OnConsentChanged(consentCheck)
                            }

                            function consentCheck() {
                                const cookieLevel = '002';
                                if (OptanonActiveGroups.indexOf(cookieLevel) > -1) {
                                    window.optimizely.push({ type: 'sendEvents' });
                                } else {
                                    window.optimizely.push({ type: 'holdEvents' });
                                }
                            }
                        `,
            }}
        />
    );
}
